import { render, staticRenderFns } from "./EiHomeBlock5.vue?vue&type=template&id=13eff2b0&scoped=true&"
import script from "./EiHomeBlock5.vue?vue&type=script&lang=js&"
export * from "./EiHomeBlock5.vue?vue&type=script&lang=js&"
import style0 from "./EiHomeBlock5.vue?vue&type=style&index=0&id=13eff2b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13eff2b0",
  null
  
)

export default component.exports